import '@mdi/font/css/materialdesignicons.css';
import Vue from 'vue'
import Vuetify from 'vuetify'


Vue.use(Vuetify)

// Disable retainFocus globally on VDialog to prevent infinite focus loop (RangeError: Maximum call stack size exceeded) with Bugsnag
Vue.mixin({
  beforeCreate() {
    const options = this.$options
    if (options.name === 'v-dialog' || options.name === 'VDialog') {
      options.propsData = {
        retainFocus: false,
        ...options.propsData
      }
    }
  }
})

const opts = {
}

export default new Vuetify(opts)
